export enum GenericInputType {
  Input = 'input',
  Dropdown = 'dropdown',
  AutoComplete = 'autoComplete',
  Date = 'date',
  AliasInput = 'aliasInput',
  AddressInput = 'addressInput',
  EmailInput = 'emailInput',
  SchoolInput = 'schoolInput',
  Checkbox = 'Checkbox',
  TextArea = 'TextArea',
  CurrencyInput = 'currencyInput',
  CountryInput = 'countryInput',
}
